import { useState } from "react";
import { FactionType } from "~/business";
import { XFactionRamp, XTypography } from "~/jsx/components/design";

export const XFactionRampTester = ({
  playerCount,
}: {
  playerCount: number;
}) => {
  const [cubeLevels, setCubeLevels] = useState(
    [...new Array(playerCount)].map((_, index) => ({
      playerId: index.toString(),
      level: index + 1,
    }))
  );

  const updateLevel = (playerId: string, newLevel: number) => {
    const obj = cubeLevels.find((_) => _.playerId === playerId);
    if (obj) {
      obj.level = newLevel;
    }
    setCubeLevels([...cubeLevels]);
  };

  const hasPoint = cubeLevels.every(({ level }) => level < 4);

  return (
    <div
      style={{
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        gap: 20,
      }}
    >
      <div>
        <XFactionRamp
          faction={FactionType.BeneGesserit}
          cubeLevels={cubeLevels}
          hasPoint={hasPoint}
        />
      </div>
      <div style={{ display: "flex", gap: 4 }}>
        {cubeLevels.map(({ playerId, level }) => (
          <div
            key={playerId}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <button onClick={() => updateLevel(playerId, level + 1)}>+</button>
            <XTypography>{level}</XTypography>
            <button onClick={() => updateLevel(playerId, level - 1)}>-</button>
          </div>
        ))}
      </div>
    </div>
  );
};
